import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import HomePage from "./pages/HomePage";
import ToursPage from "./pages/ToursPage";
import TourDetailPage from "./pages/TourDetailPage";
import BookingPage from "./pages/BookingPage";
import BookingSuccessPage from "./pages/BookingSuccessPage";
import AdminPage from "./pages/AdminPage";
import AuthCallback from "./pages/AuthCallback";
import CancellationPolicyPage from "./pages/CancellationPolicyPage";
import EnvironmentalPolicyPage from "./pages/EnvironmentalPolicyPage";
import SafetyInformationPage from "./pages/SafetyInformationPage";
import CommunitySupportPage from "./pages/CommunitySupportPage";
import BlogPage from "./pages/BlogPage";
import SurveyPage from "./pages/SurveyPage";
import VoiceAssistantWidget from "./components/VoiceAssistantWidget";
import { Toaster } from "sonner";
import useCanonical from "./hooks/useCanonical";
import { LanguageProvider } from "./i18n/LanguageContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

function AppRouter() {
  const location = useLocation();
  // Detect Emergent OAuth callback BEFORE routes — handle session_id in URL fragment
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return <AppRoutes />;
}

function AppRoutes() {
  useCanonical();
  const path = window.location.pathname;
  const hideVoiceWidget = path.startsWith('/admin') || path.startsWith('/survey');
  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/tours" element={<ToursPage />} />
        <Route path="/tours/:tourId" element={<TourDetailPage />} />
        <Route path="/booking/:tourId" element={<BookingPage />} />
        <Route path="/booking/success" element={<BookingSuccessPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/cancellation-policy" element={<CancellationPolicyPage />} />
        <Route path="/environmental-policy" element={<EnvironmentalPolicyPage />} />
        <Route path="/safety-information" element={<SafetyInformationPage />} />
        <Route path="/community-support" element={<CommunitySupportPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/survey/:bookingId" element={<SurveyPage />} />
      </Routes>
      {!hideVoiceWidget && <VoiceAssistantWidget />}
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
